import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';
import logo from '../../assets/logo.png';

export default function NotFound() {
  return (
    <div className="notfound-container">
      <img src={logo} alt="Transportes Leo" className="notfound-logo" />
      <h1 className="notfound-code">404</h1>
      <h2 className="notfound-title">Página no encontrada</h2>
      <p className="notfound-text">La página que buscás no existe o fue movida.</p>
      <Link to="/" className="notfound-btn">Volver al inicio</Link>
    </div>
  );
}
